import { z } from "zod"

export const PropertySearchSchema = z.object({
  category: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable()
    .optional(), // Optional field
  location: z
    .object({
      address: z.string(),
      coordinates: z.object({
        lat: z.number(),
        lon: z.number(),
      }),
    })
    .nullable()
    .optional(), // Optional field
  minPrice: z.number().nullable().optional(), // Optional field
  maxPrice: z.number().nullable().optional(), // Optional field
  bedrooms: z.number().nullable().optional(), // Optional field
  bathrooms: z.number().nullable().optional(), // Optional field
  amenities: z.array(z.string()).optional(), // Optional field
  keyword: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .optional(), // Optional field
  sqft: z
    .object({
      min: z.number().min(0).optional(),
      max: z.number().max(5000).optional(),
    })
    .optional(), // Optional field
})

export type PropertySearchOutput = z.infer<typeof PropertySearchSchema>
